const initMenuToggle = (menuId: string) => {
  // Mobile: main menu toggle
  const menu = document.getElementById(menuId);

  if (null === menu) {
    return;
  }

  const layer = menu.querySelector('.layer');
  const navCloseButton = menu.querySelector('.close-item');

  // Mobile: layer click > close sidebar menu
  if (null !== layer && navCloseButton) {
    const toggler = document.getElementById(`${menuId}-toggler`);
    const elems = [layer, navCloseButton];

    for (var i = 0; i < elems.length; i++) {
      elems[i].addEventListener('click', (event) => {
        event.preventDefault();
        toggler.click();
      });
    }
  }
};

export default initMenuToggle;
